/**
 * @file
 * @Function scrollToSlector
 * @description 定位页面锚点
 * @param {选择器id} selector
 */


/**
 * JS平滑滚动向下兼容处理
 *
 * @param {number} position 目标位置
 */
const scrollSmoothTo = position => {
    // 当前滚动高度
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    // 滚动step方法
    const step = () => {
        // 距离目标滚动距离
        const distance = position - scrollTop;
        // 目标滚动位置
        scrollTop = scrollTop + distance / 5;
        if (Math.abs(distance) < 1) {
            window.scrollTo(0, position);
        }
        else {
            window.scrollTo(0, scrollTop);
            setTimeout(step, 30);
        }
    };
    step();
};


/**
 * 滚动锚点
 *
 * @param {string} selector 选择器Id
 */
const scrollToId = selector => {
    let sel = document.getElementById(selector);
    if (sel) {
        // 不支持scrollBehavior平滑滚动的浏览器，如safari
        const isNotSupportBehavior = typeof window.getComputedStyle(document.body).scrollBehavior === 'undefined';
        // 火狐的scrollTop与chrome的不一致，scrollIntoView时而生效时而不生效，也需要兼容
        const isFireFox = /FireFox/i.test(navigator.userAgent);
        if (isNotSupportBehavior || isFireFox) {
            // 传统的JS平滑滚动
            scrollSmoothTo(sel.offsetTop);
            return;
        }
        sel.scrollIntoView();
    }
};

export default scrollToId;
